import { render, staticRenderFns } from "./ProuniResidenceForm.vue?vue&type=template&id=7840e3e8&scoped=true&"
import script from "./ProuniResidenceForm.vue?vue&type=script&lang=ts&"
export * from "./ProuniResidenceForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniResidenceForm.vue?vue&type=style&index=0&id=7840e3e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840e3e8",
  null
  
)

export default component.exports